import { DataIoService } from '../services/data-io.service';
import { ConfigService } from '../services/config.service';
import { SimulatorConfig } from './SimulatorConfig';
import { SimulatorModuleConfig }  from './SimulatorModuleConfig';
import { MenuLogic } from './MenuLogic';
import { MenuNode } from './MenuNode';

export class MenuLogicSnippets{
    _debug:boolean=false;

    debug(msg:string):void{
        if(this._debug){
            console.log("MenuLogicSnippets: "+msg);
        }
    }

    config:ConfigService;
    ventConfig:SimulatorModuleConfig;
    solarConfig:SimulatorModuleConfig;
    heatpumpConfig:SimulatorModuleConfig;
    boilerConfig:SimulatorModuleConfig;
    bufferCylinderConfig:SimulatorModuleConfig;
    ioService:DataIoService;
    static _instance:MenuLogicSnippets;

    static run(ioService:DataIoService){
        MenuLogicSnippets._instance = null;
        MenuLogicSnippets._instance = new MenuLogicSnippets(ioService);
    }
    constructor(ioService: DataIoService){
        this.ioService = ioService;
        this.config = this.ioService.getConfiguration();
        this.debug("Instantiating.");
        this.ventConfig = this.config.simulatorConfig.getModuleConfigByName('ventilation');
        this.solarConfig = this.config.simulatorConfig.getModuleConfigByName('solarSystem');
        this.heatpumpConfig = this.config.simulatorConfig.getModuleConfigByName('heatPump');
        this.bufferCylinderConfig = this.config.simulatorConfig.getModuleConfigByName('bufferCylinder');
        this.boilerConfig = this.config.simulatorConfig.getModuleConfigByName('boiler');
        console.log("Loading config for country: "+this.config.simulatorConfig.getCountry());    
        MenuLogic.clear();
        this.preFlight();
        this.applyVentilationFilters();
        this.applySolarSystemFilters();
        this.applyHeatpumpFilters();
        this.applyBoilerFilters();
        this.applyMiscFilters();
        this.applyHeatingCircuitFilters();
        this.installerConditions();
        this.vrc720fConditions();
        this.aiConditions();
        console.log("MenuLogicSnippets ran.");
    }
    disable(id:string){
        MenuLogic.addCriteria(id,()=>{return false;});
    }
    enable(id:string){
        MenuLogic.addCriteria(id,()=>{return true;});
    }
    aiConditions(){
        
        let sc = this.config.simulatorConfig;
        MenuLogic.addCriteria("diagnoseCode.157",()=>{
            return this.ioService.deviceInfo().getScale('d156').getCurrentElement() == 'DELIGHT_DIA_CODE_ID_156_VALUE_1';
        });
        
        MenuLogic.addCriteria("diagnoseCode.147",()=>{
            return this.ioService.deviceInfo().getScale('d146').getCurrentElement() == 'DELIGHT_DIA_CODE_ID_146_VALUE_1';
        });

        MenuLogic.addCriteria("diagnoseCode.171",()=>{
            return ['0','1','2'].includes(this.ioService.deviceInfo().getScale('d170').getCurrentElement());
        });
        
        MenuLogic.addCriteria("dataOverView.DELIGHT_DATAOVERVIEW_PRESSURE_HEAD",()=>{
            return ['0','1','2'].includes(this.ioService.deviceInfo().getScale('d170').getCurrentElement());
        })
        MenuLogic.addCriteria("diagnoseCode.172",()=>{
            return ['3'].includes(this.ioService.deviceInfo().getScale('d170').getCurrentElement());
        });
        MenuLogic.addCriteria("diagnoseCode.173",()=>{
            return ['3'].includes(this.ioService.deviceInfo().getScale('d170').getCurrentElement());
        });

        MenuLogic.addCriteria("diagnoseCode.174",()=>{
            return ['3','2','1'].includes(this.ioService.deviceInfo().getScale('d170').getCurrentElement());
        });

        MenuLogic.addCriteria("diagnoseCode.175",()=>{
            return ['4'].includes(this.ioService.deviceInfo().getScale('d170').getCurrentElement());
        });
        let weatherCompensated = ()=>{
            return this.ioService.deviceInfo().getScale('d162').getCurrentElement() == 'DELIGHT_DIA_CODE_ID_162_VALUE_1';
        };

        //MenuLogic.addCriteria("diagnoseCode.043",weatherCompensated);
        //MenuLogic.addCriteria("diagnoseCode.045",weatherCompensated);
        if(!sc.has('greeniq')|| sc.hasControl()){
            this.disable('regelung.greenIQ');
        }
        if(sc.getVariant() == 'ecoTEC plus'||sc.isSDBG()){
            this.disable('hydraulischer_abgleich');
        }

        let di = this.ioService.deviceInfo();
        let countryPrefix = this.config.getConfigPrefix();
        if(countryPrefix == 'fr'){
            di.getScale('d132').setCurrentValue(3);
        }
        if(countryPrefix == 'it'){
            di.getScale('d132').setCurrentValue(4);
        }
        if(sc.isSDBG()){
            this.disable('regelung.comfortMode');
            this.ioService.deviceInfo().setValue('comfortmode','AICI_OFF_NORMAL');
        }
        if(sc.isVaillant()){
            this.disable('diagnoseCode.031');
            this.disable('diagnoseCode.125');
            this.disable('diagnoseCode.160');
        }
        this.disable('regelung.durchRegler');
        if(sc.hasControl()){

            di.getScale('d090').setCurrentValue(1);
            this.disable('diagnoseCode.043');
            this.disable('diagnoseCode.045');
        
            console.log("Having control.");
            this.disable('schaltuhr_heizen');
            this.disable('zone.1');
            this.disable('hydraulischer_abgleich');
            
            this.disable('regelung.warmwasser.schnell');
            this.disable('regelung.warmwasser');
            this.disable('informations.current_temperatures');
            this.disable('informations.current_temperatures.ww');
            this.disable('regelung.abwesenheit');
            this.disable('stosslueften');
            this.disable('lueftung.menu.anchor');
            this.disable('wizard_zeitprogrammassistent_ohne_temperatur');
            this.disable('wizard_zeitprogrammassistent');
            this.disable('zeitprogrammassistent');
            this.disable('zeitprogrammassistent_ohne_temperatur');
            this.disable('regelung.system_off');
            this.disable('einstellungen.korrekturwert');
            this.disable('fh.anlagenkonfiguration');
            this.disable('einstellungen.zeit');
            this.disable('einstellungen.datum');
            this.disable('einstellungen.sommerzeit');
            this.disable('anchor.estrichttrocknung');
            this.disable('wizard_zeitprogrammassistent');
            this.disable('benutzerhandbuch_zeitprogrammassistent');
            this.disable('zonename.1');

            this.disable('diagnoseCode.008');
            //this.disable('diagnoseCode.009');
            //this.disable('diagnoseCode.047');
            this.disable('diagnoseCode.062');
            this.disable('diagnoseCode.162');
        }

        if(sc.witterungsgefuehrt()){
            this.disable('diagnoseCode.009');
            this.disable('diagnoseCode.025');
        
            console.log("Having witterungsgefuehrt.");
            this.disable('diagnoseCode.008');
            this.disable('diagnoseCode.009');
            this.disable('diagnoseCode.062');

            this.disable('zone.1');
            this.disable('schaltuhr_heizen');
            //this.disable('regelung.greenIQ');
            this.disable('regelung.warmwasser.schnell');
            //this.disable('hydraulischer_abgleich');
            this.disable('fh.anlagenkonfiguration');
            this.disable('anchor.estrichttrocknung');
            this.disable('regelung.warmwasser');
            this.disable('zeitprogrammassistent');
            this.disable('wizard_zeitprogrammassistent')
            this.disable('zeitprogrammassistent_ohne_temperatur');
            //this.disable('regelung.comfortMode');
            this.disable('regelung.abwesenheit');
            this.disable('stosslueften');
            this.disable('lueftung.menu.anchor');
            this.disable('informations.current_temperatures');
            this.disable('informations.current_temperatures.ww');
            this.disable('regelung.system_off');
            this.disable('zeitprogrammassistent');
            this.disable('benutzerhandbuch_zeitprogrammassistent');
            this.disable('zeitprogrammassistent_ohne_temperatur');
            this.disable('wizard_zeitprogrammassistent');
            this.disable('wizard_zeitprogrammassistent_ohne_temperatur');
            //this.disable('einstellungen.korrekturwert');
        }
        if(sc.isStandalone()){
            this.disable('diagnoseCode.009');
            this.disable('diagnoseCode.025');
            this.disable('diagnoseCode.043');
            this.disable('diagnoseCode.045');
            this.disable('diagnoseCode.047');
            console.log("Having standalone.");
            di.getScale('d090').setCurrentValue(0);

            //this.disable('diagnoseCode.008');
            //this.disable('diagnoseCode.009');
            //this.disable('diagnoseCode.047');
            this.disable('diagnoseCode.062');
            this.disable('diagnoseCode.162');
            this.disable('zone.1');
            this.disable('benutzerhandbuch_zeitprogrammassistent');
            this.disable('wizard_zeitprogrammassistent_ohne_temperatur'),
            this.disable('zeitprogrammassistent_ohne_temperatur');
            this.disable('zeitprogrammassistent');
            this.disable('wizard_zeitprogrammassistent');
            
            this.disable('schaltuhr_heizen');
            //this.disable('regelung.greenIQ');
            this.disable('regelung.warmwasser.schnell');
            //this.disable('hydraulischer_abgleich');
            this.disable('fh.anlagenkonfiguration');
            this.disable('anchor.estrichttrocknung');
            this.disable('regelung.warmwasser');
            //this.disable('regelung.comfortMode');
            this.disable('regelung.abwesenheit');
            this.disable('stosslueften');
            this.disable('lueftung.menu.anchor');
            this.disable('regelung.system_off');
            this.disable('einstellungen.korrekturwert');
            this.disable('informations.current_temperatures');
            this.disable('informations.current_temperatures.ww');
        }
        if(sc.hasSensoDIRECT()){
            //this.disable('zone.1');
            //this.disable('zeitprogrammassistent');
            this.disable('wizard_zeitprogrammassistent_ohne_temperatur')
            this.disable('zeitprogrammassistent_ohne_temperatur');
            this.disable('schaltuhr_heizen');
            this.disable('informations.current_temperatures');
            
        }
    }
    vrc720fConditions(){
        
        MenuLogic.addCriteria('anchor-config-radio-connection',()=>{
            return this.config.simulatorConfig.hasRadio();
        });
        MenuLogic.addCriteria('wizard_empfangsstaerke_sensor',()=>{
            return this.config.simulatorConfig.hasRadio();
        });
        MenuLogic.addCriteria('wizard_empfangsstaerke_regler',()=>{
            return this.config.simulatorConfig.hasRadio();
        });
        
        MenuLogic.addCriteria('zonenzuordnung_fernbedienung_3',()=>{
           return this.config.simulatorConfig.isVariant('vrc720'); 
        })
        MenuLogic.addCriteria('zonenzuordnung_fernbedienung_4',()=>{
           return this.config.simulatorConfig.isVariant('vrc720'); 
        })
        
    }
    installerConditions(){
        
        let installer_condition_1 = ()=>{
            return this.ioService.deviceInfo().getRawValue('remote_connected')=='WIZARD_REMOTE_CONTROLS_OPTION_ENUM1';
        }
        
        MenuLogic.addCriteria('confirm_remote',installer_condition_1);
        let installer_condition_2 = (node:MenuNode)=>{
            let hasSufficientHeatingCircuitCount = (this.config.simulatorConfig.heatingCircuitCount() >= 2);
            let hasBufferCylinder = (this.config.simulatorConfig.hasBufferCylinder());
            let hasSolarBuffer = (this.config.simulatorConfig.hasSolar());
            return hasSolarBuffer || hasSufficientHeatingCircuitCount || hasSolarBuffer;
        }
        let installer_condition_2_1 = (node:MenuNode)=>{
            let hasSufficientHeatingCircuitCount = (this.config.simulatorConfig.heatingCircuitCount() >= 2);
            let hasBufferCylinder = (this.config.simulatorConfig.hasBufferCylinder());
            let hasSolarBuffer = (this.config.simulatorConfig.hasSolar());
            return hasSolarBuffer || hasSufficientHeatingCircuitCount || hasSolarBuffer|| this.config.simulatorConfig.hasVR7x();
        }
        MenuLogic.addCriteria('installer_solar_buffer_options',installer_condition_2);
        MenuLogic.addCriteria('installer_warning',installer_condition_2_1);
        MenuLogic.addCriteria('wizard-device-list',installer_condition_2);
        let vr71config_setter = ()=>{
            this.ioService.deviceInfo().getHooks().setInstallerVR71Config();
            return true;
        }
        
        MenuLogic.addCriteria('wizard-device-list',vr71config_setter);
        

        let installer_condition_3 = ()=>{
            let hasSufficientHeatingCircuitCount = (this.config.simulatorConfig.heatingCircuitCount() > 2);
            let hasAllStor = this.config.simulatorConfig.hasAllStor();
            let hasSolar = this.config.simulatorConfig.hasSolar();
            let di = this.ioService.deviceInfo();
            let solarOption = di.getRawValue('wizard_solar_option');
            let solarSettingsCondition = ( (solarOption!='WIZARD_SOLAR_OPTIONS_ENUM1') && (solarOption!='WIZARD_SOLAR_OPTIONS_ENUM2') );
            let enabled = ( (hasSufficientHeatingCircuitCount|| hasSolar || hasAllStor) && (solarSettingsCondition) )
            return enabled;
        }
        let onlyHeatpumpCondition = ()=>{
            if(this.config.simulatorConfig.hasHeatpump() && !this.config.simulatorConfig.hasVR7x()){
                return false;
            }
            return true;
        }
        MenuLogic.addCriteria('zone_option_3',onlyHeatpumpCondition);
        MenuLogic.addCriteria('zone_option_4',onlyHeatpumpCondition);
        MenuLogic.addCriteria('zone_option_5',onlyHeatpumpCondition);

        MenuLogic.addCriteria('installer_solar_buffer_count',installer_condition_3);

        let installer_condition_4 = ()=>{
            //console.log("Evaluating installer_condition_4");
            let hasBufferStorage = this.config.simulatorConfig.hasBufferCylinder();
            let hasSufficientHeatingCircuitCount = (this.config.simulatorConfig.heatingCircuitCount() == 2);
            let systemSchemaCodeCondition = this.ioService.deviceInfo().getScale('systemschema_code').getCurrentValue() == 8;
            /*
            console.log("Bufferstorage: "+( (hasSufficientHeatingCircuitCount)?"yes":"no"));
            console.log("HasSufficient: "+( (hasBufferStorage)?"yes":"no"));
            console.log("syscode: "+( (systemSchemaCodeCondition)?"yes":"no"));
            console.log("VR70Count: "+this.config.simulatorConfig.getVR70Count());
            console.log("VR71Count: "+this.config.simulatorConfig.getVR71Count());
            */
            if(this.hasHeatpump() && this.config.simulatorConfig.getVR71Count() == 0){
                return true;
            }
            return (hasBufferStorage|| hasSufficientHeatingCircuitCount|| systemSchemaCodeCondition) && (this.config.simulatorConfig.getVR70Count()>0 && this.config.simulatorConfig.getVR71Count() == 0);
        }
        MenuLogic.addCriteria('installer_zone_options',installer_condition_4);
        
        let installer_condition_5 = ()=>{
            let hasBufferStorage = this.config.simulatorConfig.hasBufferCylinder();
            let hasSufficientHeatingCircuitCount = (this.config.simulatorConfig.heatingCircuitCount() == 2);

            let val = (hasBufferStorage|| hasSufficientHeatingCircuitCount) && (this.config.simulatorConfig.getVR70Count()>0 && this.config.simulatorConfig.getVR71Count() == 0);

            return (hasBufferStorage|| hasSufficientHeatingCircuitCount) && (this.config.simulatorConfig.getVR70Count()>0 && this.config.simulatorConfig.getVR71Count() == 0);
        }

        MenuLogic.addCriteria('wizard_mavr70_options',installer_condition_5);
        
        let installer_condition_6 = ()=>{
            let hasSufficientHeatingCircuitCount = (this.config.simulatorConfig.heatingCircuitCount() > 2);
            let hasAllStor = this.config.simulatorConfig.hasAllStor();
            let hasSolar = this.config.simulatorConfig.hasSolar();
            return  ( hasSufficientHeatingCircuitCount || hasAllStor || hasSolar ) && ( this.config.simulatorConfig.hasVR71() );
        }

        MenuLogic.addCriteria('wizard_heatingcircuit_count',installer_condition_6);
        MenuLogic.addCriteria('wizard_mavr71_options',installer_condition_6);
        let installer_condition_7 = ()=>{
            return this.config.simulatorConfig.hasHeatpump() && this.ioService.deviceInfo().getScale('systemschema_code').getCurrentValue() >= 8;
        }

        MenuLogic.addCriteria('wizard_ma2_option',installer_condition_7);
        let installer_condition_8 = ()=>{
            // implemented by menu
        }
        

        let onlyBoilers = ()=>{
            let config = this.config.simulatorConfig;
            let hasHeatGenerator = config.hasBoiler();
            let hasSomethingElse = config.solarCylinderCount() || config.hasBufferCylinder() || config.hasHeatpump() || config.heatingCircuitCount() > 1; // ignore ventilation
            if(hasHeatGenerator && !hasSomethingElse){
                return false;
            }
            return true;
        };
        MenuLogic.addCriteria('wizard_systemschema_code',onlyBoilers)
    }


    preFlight(){

        /**
            Wenn eine Wärmepumpe und ein Heizgerät gewählt sind Systemschema-Code „8“, wenn mehrere Wärmepumpen und ein Heizgerät gewählt sind Systemschema-Code „16“.
        **/
        let boilerCount = this.boilerCount();
        let heatpumpCount = this.heatpumpCount();
        let systemCode = 0;
        if(boilerCount > 0 && heatpumpCount == 0){
            systemCode = 1;
        }
        if(boilerCount == 1 && heatpumpCount == 1){
            systemCode = 8;
        }
        if(heatpumpCount > 1){
            if(this.config.simulatorConfig.showInstallation()){
                systemCode = 8;
            }else{
                systemCode = 16;
    
            }
        }


        /**
            nur ventilation
        **/
        if(this.config.simulatorConfig.justVentilation()){
            let di = this.ioService.deviceInfo();
            let dz = di.getDefaultZone();
            let dh = di.getDefaultHeatingCircuit();
            dz.setValue('zone_active','ENUM_ZONE_ENABLED_NO');
            dh.setValue('circuitType','ENUM_TYPE_OF_CIRCUIT_DEACTIVATED');
            dz.setValue('warmwasserspeicher','ENUM_TYPE_OF_DHW_CIRCUIT_DEACTIVATED');
            let justVentilationCriteria = ()=>{ return !this.config.simulatorConfig.justVentilation()};
            
            MenuLogic.addCriteria('info.wasserdruck',justVentilationCriteria);
            MenuLogic.addCriteria('config-zone-1',justVentilationCriteria);
            MenuLogic.addCriteria('kreis-1-entry',justVentilationCriteria);
            MenuLogic.addCriteria('brennerzustand',justVentilationCriteria);
            MenuLogic.addCriteria('anchor-config-estrichttrocknungsprofil',justVentilationCriteria);
            MenuLogic.addCriteria('anchor.estrichttrocknung',justVentilationCriteria);
            MenuLogic.addCriteria('info.vorlauftemperatur-anlage',justVentilationCriteria);

            this.ioService.deviceInfo().getScale('systemschema_code').setCurrentValue(1);
        }




        this.ioService.deviceInfo().getScale('solar_buffer_count').setCurrentValue(this.config.simulatorConfig.solarCylinderCount());

        if(systemCode > 0){
            this.ioService.deviceInfo().getScale('systemschema_code').setCurrentValue(systemCode);
        }
        if(this.hasHeatpump()){

            for(let zoneId of this.ioService.deviceInfo().getZoneIds()){
                let zone = this.ioService.deviceInfo().getZoneById(zoneId);
                zone.getSensor('temperature','water_nominal').setCurrentValue(55);
            }

            for(let hcId of this.ioService.deviceInfo().getHeatingCircuitIds()){
                let hc = this.ioService.deviceInfo().getHeatingCircuitById(hcId);
                hc.getScale('warmwassertemperatur').setCurrentValue(55);
                hc.getScale('max_vorlauf_soll_temperatur').setCurrentValue(55);
                hc.getScale('heizkurve').setCurrentValue(0.6);
            }
        }else{

            for(let zoneId of this.ioService.deviceInfo().getZoneIds()){
                let zone = this.ioService.deviceInfo().getZoneById(zoneId);
                zone.getSensor('temperature','water_nominal').setCurrentValue(60);
            }

            for(let hcId of this.ioService.deviceInfo().getHeatingCircuitIds()){
                let hc = this.ioService.deviceInfo().getHeatingCircuitById(hcId);
                hc.getScale('warmwassertemperatur').setCurrentValue(60);
                hc.getScale('heizkurve').setCurrentValue(1.2);
            }
        }

        if(this.config.simulatorConfig.solarCylinderCount() == 1){
            this.ioService.deviceInfo().getScale('configuration_vr71').setCurrentValue(2);
        }
        
        if(this.config.simulatorConfig.solarCylinderCount() == 2){
            this.ioService.deviceInfo().getScale('configuration_vr71').setCurrentValue(1);
        }

        if(this.config.simulatorConfig.hasAllStor() && this.config.simulatorConfig.hasVR71()){
             this.ioService.deviceInfo().getScale('configuration_vr71').setCurrentValue(6);   
        }

        if(!this.config.simulatorConfig.showInstallation()){
            this.ioService.deviceInfo().setValue('wizard_help_shown','true');
        }
        this.ioService.deviceInfo().getHooks().setDefaultVR71Config();

        let activeHeatingCircuits = this.config.simulatorConfig.activeHeatingCircuits();
        let availableHeatingCircuits = this.config.simulatorConfig.heatingCircuitCount();
        let ids = this.ioService.deviceInfo().getHeatingCircuitIds();
        for(let id of ids){
            let hc = this.ioService.deviceInfo().getHeatingCircuitById(id);
            if(id > activeHeatingCircuits){
                hc.setValue('circuitType','ENUM_TYPE_OF_CIRCUIT_DEACTIVATED');
            }
        }

    }
    applyHeatingCircuitFilters(){
        let condition_12_2 = ()=>{
            return this.isMixedCircuit();
        };
        MenuLogic.addCriteria('status.mixer',condition_12_2);
        MenuLogic.addCriteria('vorlaufisttemp',condition_12_2);
    }
    applyHeatpumpFilters(){

        MenuLogic.addCriteria("energy_consumption_cooling",()=>{return this.config.simulatorConfig.hasHeatpump();});
        if(!this.hasHeatpump()){

            // das hier alles wird ausgeblendet, wenn keine wärmepumpe konfiguriert wurde.    
            let heatpumpInfluences = [
            'kuehlen_fuer_einige_tage',
            'umweltertrag',
            'tarife',
            'konfiguration-wp-regelungsmodul',
            'fluesterbetrieb',
            'feuchteschutz',
            'wp-regelungsmodul',
            'kuehlen_bei_aussentemperatur',
            'quellenregenerierung',
            'hybridmanager',
            'bivalenzpunkt_heizen',
            'bivalenzpunkt_warmwasser',
            'alternativpunkt',
            'temperatur_notbetrieb',
            'evu',
            'zusatzheizgeraet',
            'zusatzheizgeraet_typ',
            'offset_pufferspeicher',
            'automatisch_kuehlen',
            'aktueller_taupunkt',
            'hysterese.speicherladung'
            ]
            let heatpumpPerHC=[
                'kuehlen.',
                'config_kuehlen_moeglich.',
                'config_taupunktueberwachung.',
                'config_min_vorlauftemperatur_kuehlen.',
                'config_offset_taupunkt.'
            ]
            for(let i of this.ioService.deviceInfo().getHeatingCircuitIds()){
                for(let id of heatpumpPerHC){
                    heatpumpInfluences.push(id+i.toString());
                }
            }
            for(let identifier of heatpumpInfluences){
                MenuLogic.addCriteria(identifier,()=>{return false;});
            }
            MenuLogic.addCriteria('brennerzustand',()=>{ return true; });
            MenuLogic.addCriteria('aussentemp_gemittelt',()=>{ return false; });
            
        }
        for(let id of this.ioService.deviceInfo().getHeatingCircuitIds()){
            MenuLogic.addCriteria('externe-waermeanforderung-'+id.toString(),()=>{
                    return (this.config.simulatorConfig.hasVR7x());
                });
        }    
        if(this.hasHeatpump()){
            MenuLogic.addCriteria('brennerzustand',()=>{ return false; });
            MenuLogic.addCriteria('aussentemp_gemittelt',()=>{ return true; });
            
            // das hier alles wird ausgeblendet, wenn keine wärmepumpe konfiguriert wurde.    
            let heatingCircuitIds = this.ioService.deviceInfo().getHeatingCircuitIds();
            for(let id of heatingCircuitIds){
                MenuLogic.addCriteria('kuehlen.'+id.toString(),()=>{
                    return (this.ioService.deviceInfo().getHeatingCircuitById(id).getRawValue('kuehlen_moeglich')=='ENUM_COOLING_ALLOWED_YES');
                });
                MenuLogic.addCriteria('config_min_vorlauftemperatur_kuehlen.'+id.toString(),()=>{
                    return this.ioService.deviceInfo().getHeatingCircuitById(id).getRawValue('kuehlen_moeglich')=='ENUM_COOLING_ALLOWED_YES';
                });
            }
            MenuLogic.addCriteria('bivalenzpunkt_heizen',()=>{
                return (this.ioService.deviceInfo().getRawValue('hybridmanager')!='ENUM_HYBRID_MANAGER_TRIVAI');
            });

 
            MenuLogic.addCriteria('kuehlen_fuer_einige_tage',()=>{
                    return (this.ioService.deviceInfo().getDefaultHeatingCircuit().getRawValue('kuehlen_moeglich')=='ENUM_COOLING_ALLOWED_YES');
                });
            
            MenuLogic.addCriteria('feuchteschutz',()=>{
                    return (this.ioService.deviceInfo().getRawValue('configuration_wp_ma2')=='ENUM_HP_MODUL_OUTPUT_2_DEHUMIDIFIER');
                });
            
            MenuLogic.addCriteria('tarife',()=>{
                return (this.ioService.deviceInfo().getRawValue('hybridmanager')=='ENUM_HYBRID_MANAGER_TRIVAI');
            });
            MenuLogic.addCriteria('zusatzheizgeraet_typ',()=>{
                return (this.ioService.deviceInfo().getRawValue('hybridmanager')=='ENUM_HYBRID_MANAGER_TRIVAI');
            });
            MenuLogic.addCriteria('aktueller_taupunkt',()=>{
                return (
                    this.ioService.deviceInfo().getDefaultHeatingCircuit().getRawValue('kuehlen_moeglich')=='ENUM_COOLING_ALLOWED_YES') && 
                    ( 
                        (this.ioService.deviceInfo().getDefaultHeatingCircuit().getRawValue('raumaufschaltung')=="ENUM_ROOM_TEMPERATURE_INFLUENCE_SWITCH_ON"||
                           (this.ioService.deviceInfo().getDefaultHeatingCircuit().getRawValue('raumaufschaltung')=="ENUM_ROOM_TEMPERATURE_INFLUENCE_THERMOSTAT")
                       )
                );
            });
            for(let hc of this.ioService.deviceInfo().getHeatingCircuitIds()){
                let taupunkt_condition = ()=>{
                    return (
                    this.ioService.deviceInfo().getDefaultHeatingCircuit().getRawValue('kuehlen_moeglich')=='ENUM_COOLING_ALLOWED_YES') && 
                    ( 
                        (this.ioService.deviceInfo().getDefaultHeatingCircuit().getRawValue('raumaufschaltung')=="ENUM_ROOM_TEMPERATURE_INFLUENCE_SWITCH_ON"||
                           (this.ioService.deviceInfo().getDefaultHeatingCircuit().getRawValue('raumaufschaltung')=="ENUM_ROOM_TEMPERATURE_INFLUENCE_THERMOSTAT")
                       )
                        );
                };
                MenuLogic.addCriteria('config_offset_taupunkt.'+hc.toString(),taupunkt_condition);
                MenuLogic.addCriteria('config_taupunktueberwachung.'+hc.toString(),taupunkt_condition);
            }
        }
    }



    applyBufferCylinderFilters(){
    }


    applyBoilerFilters(){
        /*
        if(!(this.boilerConfig.isAvailable() && this.boilerConfig.getValue()=="ecoTecExclusive")){
            MenuLogic.addCriteria('brennstoffverbrauch',()=>{return false;});
        }*/
    }
    hasBoiler(){
        return this.config.simulatorConfig.hasBoiler();
    }
    hasSolar(){
        return this.config.simulatorConfig.hasSolar();
    }
    allStorConfigured(){
        return  (this.config.simulatorConfig.hasVR70() && this.ioService.deviceInfo().vr70() == 3);
    }
    solarConfigured(){
        return  (this.config.simulatorConfig.hasVR70() && [6,12].includes(this.ioService.deviceInfo().vr70()) );
    }
    hasAllStor(){
        return this.config.simulatorConfig.hasAllStor();
    }
    hasHeatpump(){
        return this.config.simulatorConfig.hasHeatpump();
    }
    boilerCount(){
        return this.config.simulatorConfig.boilerCount();
    }
    heatpumpCount(){
        return this.config.simulatorConfig.heatpumpCount();
    }

    heatingCircuitCount(){
        return this.config.simulatorConfig.heatingCircuitCount();
    }
    applyMiscFilters(){
        let vc = this.ventConfig;
        let hpc = this.heatpumpConfig;
        let bcc = this.bufferCylinderConfig;
        let condition_hasEnabledChilds = (node:MenuNode)=>{

            for(let child of node.getChilds()){
                for(let subChild of child.getChilds()){
                    if(subChild.isEnabled()){
                        return true;
                    }
                }
            }
            return false;
        };
        MenuLogic.addCriteria('anchor.energiedaten',condition_hasEnabledChilds);
        MenuLogic.addCriteria('anchor.config.buffercylinder',(node)=>{return (condition_hasEnabledChilds(node));} );
        MenuLogic.addCriteria('regelung.warmwasser',()=>{
            return this.ioService.deviceInfo().getDefaultZone().getRawValue('warmwasserspeicher')=='ENUM_TYPE_OF_DHW_CIRCUIT_DHW';
        });

        MenuLogic.addCriteria('regelung.warmwasser.schnell',()=>{
            return this.ioService.deviceInfo().getDefaultZone().getRawValue('warmwasserspeicher')=='ENUM_TYPE_OF_DHW_CIRCUIT_DHW';
        });

        MenuLogic.addCriteria('ansteuerumkehr',()=>{return this.heatpumpCount()>1 || this.boilerCount()>1;});
        MenuLogic.addCriteria('ansteuerreihenfolge',()=>{return this.heatpumpCount()>1 || this.boilerCount()>1;});

        MenuLogic.addCriteria('config_vr70',()=>{return this.config.simulatorConfig.hasVR70();});
        MenuLogic.addCriteria('config_ma_vr70',()=>{return this.config.simulatorConfig.hasVR70();});
    
        MenuLogic.addCriteria('config_vr71',()=>{return this.config.simulatorConfig.hasVR71();});
        MenuLogic.addCriteria('config_ma_vr71',()=>{return this.config.simulatorConfig.hasVR71();});    
        MenuLogic.addCriteria('sensor-aktor-test-menu',()=>{return this.config.simulatorConfig.hasVR7x();})
        MenuLogic.addCriteria('sensor-aktor-test-hook',()=>{return this.config.simulatorConfig.hasVR7x();})
        MenuLogic.addCriteria('konf.ext.eingaenge',()=>{return this.config.simulatorConfig.hasVR7x();})
        // 12.8
        let ids_12_8 = [ 
        'config.warmwasser.speicherladepumpe',
        'config.warmwasser.speicherladung_offset',
        'config.warmwasser.max_speicherladezeit',
        'config.warmwasser.sperrzeit_speicherladung'
        ];
        let condition_12_8 = ()=>{
            let sc = this.ioService.deviceInfo().getScale('systemschema_code').getCurrentValue();
            
            if([2,10,11,12,13,16].includes(sc)){
                return true;
            }

            if(sc == 1 && (this.hasSolar() || this.hasAllStor() || this.allStorConfigured() || this.solarConfigured()) ){
                return true;
            }
            if( (sc == 8) && (this.heatpumpCount() > 0) && (this.boilerCount() == 0) ){
                return true;
            }
            return false;

        }
        for(let id of ids_12_8){
            MenuLogic.addCriteria(id,condition_12_8);
        }
        // 12.9
        let condition_12_9 = ()=>{
            let di = this.ioService.deviceInfo();
            return (this.config.simulatorConfig.hasVR70() && di.vr70()==1) || (this.config.simulatorConfig.hasVR71() && di.vr71() == 3 && [1,2,8,9,10,11,12,13,16].includes(di.system_scheme()));
        };
        MenuLogic.addCriteria('buffer_top',condition_12_9);
        MenuLogic.addCriteria('buffer_bottom',condition_12_9);
        // 12.10        
        let condition_12_10 = ()=>{
            let di = this.ioService.deviceInfo();
            return di.vr71()==6 || di.vr70() == 3;
        };
        MenuLogic.addCriteria('buffer_top_dhw',condition_12_10);
        MenuLogic.addCriteria('buffer_bottom_dhw',condition_12_10);
        MenuLogic.addCriteria('buffer_top_ch',condition_12_10);
        MenuLogic.addCriteria('buffer_bottom_ch',condition_12_10);
        MenuLogic.addCriteria('max_ww_inlet_nominal',condition_12_10);
        MenuLogic.addCriteria('buffer_solar_1_temp',condition_12_10);
        // 12.11
        let condition_12_11 = ()=>{
            /*
            console.log("solar buffer count: "+this.ioService.deviceInfo().getScale('solar_buffer_count'));
            console.log("VR71Config: "+this.ioService.deviceInfo().vr71());
            */
            let di = this.ioService.deviceInfo();
            return ( (di.vr70() == 3) || (di.vr71()==6)) && di.getScale('solar_buffer_count').getCurrentValue()==2;
        };
        MenuLogic.addCriteria('solarbuffer_2_bottom',condition_12_11);
        MenuLogic.addCriteria('buffer_solar_2_maxtemp',condition_12_11);
        for(let hcId of this.ioService.deviceInfo().getHeatingCircuitIds()){
            let zoneActiveCondition=()=>{
                return this.ioService.deviceInfo().getHeatingCircuitIds().includes(hcId) && (this.ioService.deviceInfo().getHeatingCircuitById(hcId).getRawValue('circuitType')!="ENUM_TYPE_OF_CIRCUIT_DEACTIVATED");
            };
            MenuLogic.addCriteria('zone.'+hcId,zoneActiveCondition);
            
            MenuLogic.addCriteria('zone.abwesenheit.'+hcId,zoneActiveCondition);
            
            MenuLogic.addCriteria('config-zone-'+hcId,zoneActiveCondition);
        }
        for(let zId of this.ioService.deviceInfo().getZoneIds()){
            let zoneActivatedCondition=()=>{
                return (this.ioService.deviceInfo().getZoneById(zId).getRawValue('zone_active')=="ENUM_ZONE_ENABLED_YES");  
            }
            MenuLogic.addCriteria('zone.abwesenheit.'+zId,zoneActivatedCondition);
            MenuLogic.addCriteria('zone.'+zId,zoneActivatedCondition);
        }
        MenuLogic.addCriteria('sensor-aktor-test-vr70-3',()=>{
            return (this.ioService.deviceInfo().getVR70Count() > 2);
        });
        MenuLogic.addCriteria('sensor-aktor-test-vr70-2',()=>{
            return (this.ioService.deviceInfo().getVR70Count() > 1);
        });
        MenuLogic.addCriteria('sensor-aktor-test-vr70-1',()=>{
            return (this.ioService.deviceInfo().getVR70Count() >= 1);
        });
         MenuLogic.addCriteria('sensor-aktor-test-vr71',()=>{
            return this.config.simulatorConfig.hasVR71();
        });
           
    }
    applyVentilationFilters(){

        if(!(this.ventConfig.isAvailable()) || this.ventConfig.getValue() == "no"){
              MenuLogic.addCriteria('lueftung.menu.anchor',()=>{return false;});    
              MenuLogic.addCriteria('waermerueckgewinnung',()=>{return false;});    
        }
    }
    applySolarSystemFilters(){

        MenuLogic.addCriteria('solarertrag',()=>{
            let hasVR71 = this.config.simulatorConfig.hasVR71();
            let vr71_value = this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue();
            let solarCylinderCount = this.config.simulatorConfig.solarCylinderCount();

            return ([2,1].includes(vr71_value) && hasVR71 && solarCylinderCount > 0) || (this.solarConfigured()) ;
        });
       MenuLogic.addCriteria('solarkreis',()=>{
           let solarCylinderCount = this.config.simulatorConfig.solarCylinderCount();
            let vr71_value = this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue();
            let hasVR71 = this.config.simulatorConfig.hasVR71();
            return ([2,1].includes(vr71_value) && hasVR71 && solarCylinderCount > 0) || (this.solarConfigured());
            
       });
        MenuLogic.addCriteria('solarspeicher1',()=>{
            let solarCylinderCount = this.config.simulatorConfig.solarCylinderCount();
            let hasVR71 = this.config.simulatorConfig.hasVR71();
            let vr71_value = this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue();
            return ([2,1].includes(vr71_value) && hasVR71 && solarCylinderCount > 0) || (this.solarConfigured());
        });
        MenuLogic.addCriteria('solarspeicher2',()=>{
            let solarCylinderCount = this.config.simulatorConfig.solarCylinderCount();
            let vr71_value = this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue();
            let hasVR71 = this.config.simulatorConfig.hasVR71();
            return ( (vr71_value == 1 && hasVR71 && solarCylinderCount == 2)|| (this.solarConfigured() && solarCylinderCount == 2) );
        }); 
        MenuLogic.addCriteria('menuentry-2nd-td',()=>{
            let solarCylinderCount = this.config.simulatorConfig.solarCylinderCount();
            let vr71_value = this.ioService.deviceInfo().getScale('configuration_vr71').getCurrentValue();
            let hasVR71 = this.config.simulatorConfig.hasVR71();
            let vr70_value = this.ioService.deviceInfo().getScale('configuration_vr70').getCurrentValue()
            let isTDControl = this.ioService.deviceInfo().getRawValue('configuration_ma_vr71')=='ENUM_MAVR71_DT_CONTROL';
            //console.log("SolarCylinderCount:" +solarCylinderCount);
            return ( [2,1].includes(vr71_value) && hasVR71 && isTDControl && [2,1].includes(solarCylinderCount) ) || (this.solarConfigured() && vr70_value == 12);
        });

    }
    isMixedCircuit(){
        let hcCount = this.heatingCircuitCount();
        let wizard_zone_option = this.ioService.deviceInfo().getRawValue('wizard_zone_option');
        let mixed_options = ['WIZARD_ZONE_OPTIONS_ENUM3','WIZARD_ZONE_OPTIONS_ENUM4','WIZARD_ZONE_OPTIONS_ENUM5'];
        if( (hcCount > 1) || (hcCount == 1 && mixed_options.includes(wizard_zone_option)) ){
            return true;
        }
        return false;
    }
}